import { render, staticRenderFns } from "./LeftBox.vue?vue&type=template&id=fda3c574&scoped=true&"
import script from "./LeftBox.vue?vue&type=script&lang=js&"
export * from "./LeftBox.vue?vue&type=script&lang=js&"
import style0 from "./LeftBox.vue?vue&type=style&index=0&id=fda3c574&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda3c574",
  null
  
)

export default component.exports